import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
} from "@angular/material/dialog";

@Component({
	selector: "app-confirm-dialog",
	templateUrl: "./confirm-dialog.component.html",
	styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
	@Output() onConfirm: EventEmitter<boolean> = new EventEmitter();
	public MessageText: string;
	public ConfirmText: string;
	public CancelText: string;
	public ShowCancelButton: boolean;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
	) {}

	ngOnInit(): void {
		this.MessageText = "shared.confirmDialog.defaultMessage";
		this.ConfirmText = "shared.confirmDialog.defaultConfirm";
		this.CancelText = "shared.confirmDialog.defaultCancel";

		if (this.data) {
			this.MessageText =
				this.data.messageText ?? "shared.confirmDialog.defaultMessage";
			this.ConfirmText =
				this.data.confirmText ?? "shared.confirmDialog.defaultConfirm";
			this.CancelText =
				this.data.cancelText ?? "shared.confirmDialog.defaultCancel";
			this.ShowCancelButton = this.data.showCancelButton;
		}
	}

	confirm() {
		this.onConfirm.emit(true);
		this.dialogRef.close(true);
	}

	cancel() {
		this.dialogRef.close(false);
	}
}
